<div class="spinner-wrapper" *ngIf="showLoader">
  <mat-spinner></mat-spinner>
</div>
<div class="container design-overview-wrapper">
  <form focusInvalidInput class="form" #locationForm="ngForm">
    <h2>Locations</h2>
    <hr>

    <div class="row">
      <div class="design-overview-wrapper__item col-md-6 col-12 px-3">
        <mat-form-field class="example-full-width" appearance="fill">
          <mat-label>Search Address</mat-label>
          <input type="text" placeholder="Enter a address name" matInput [(ngModel)]="street_address"
            [matAutocomplete]="autoAddress" #searchAddress [ngModelOptions]="{standalone: true}">
          <mat-autocomplete #autoAddress="matAutocomplete" autoActiveFirstOption [displayWith]="displaySelectedAddress">
            <mat-option *ngFor="let address of selectedAddress" (click)="onAddressSelection(address)" [value]="address">
              {{address?.street_address}}
            </mat-option>
          </mat-autocomplete>

        </mat-form-field>
        <button mat-flat-button (click)="onAddressSelection(street_address)" class=" system" color="accent">
          Search Address
        </button>
      </div>


      <div class="design-overview-wrapper__item col-md-6 col-12 px-3">
        <mat-form-field class="example-full-width" appearance="fill">
          <mat-label>Search Subdivision Name</mat-label>
          <input type="text" placeholder="Enter a subdivision name" matInput [(ngModel)]="searchSubDivisionName"
            [matAutocomplete]="auto" #searchSubDivision [ngModelOptions]="{standalone: true}">
          <mat-autocomplete #auto="matAutocomplete" autoActiveFirstOption [displayWith]="displaySelectedSubdivision">
            <mat-option *ngFor="let subDivision of selectedSubDivision" (click)="onSubDivisionSelection(subDivision)"
              [value]="subDivision">
              {{subDivision?.subdivision_name}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
        <button mat-flat-button (click)="onSubDivisionSelection(searchSubDivisionName)" class=" system" color="accent">
          Search Subdivision
        </button>
      </div>

      <div class="design-overview-wrapper__item col-md-6 col-12 px-3">
        <mat-form-field class="example-full-width" appearance="fill">
          <mat-label>Search City Name</mat-label>
          <input type="text" placeholder="Enter a city name" matInput [(ngModel)]="searchCity"
            [matAutocomplete]="autoCity" #searchCities [ngModelOptions]="{standalone: true}">
          <mat-autocomplete #autoCity="matAutocomplete" autoActiveFirstOption [displayWith]="displaySelectedCity">
            <mat-option *ngFor="let selectCity of selectCities" (click)="onCitySelection(selectCity)"
              [value]="selectCity">
              {{selectCity?.city}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
        <button mat-flat-button (click)="onCitySelection(searchCity)" class=" system" color="accent">
          Search Cities
        </button>
      </div>


      <div class="design-overview-wrapper__item col-md-6 col-12 px-3">
        <mat-form-field class="example-full-width" appearance="fill">
          <mat-label>Search Plans Name</mat-label>
          <input type="text" placeholder="Enter a plans name" matInput [(ngModel)]="searchPlans"
            [matAutocomplete]="autoPlans" #searchPlan [ngModelOptions]="{standalone: true}">
          <mat-autocomplete #autoPlans="matAutocomplete" autoActiveFirstOption [displayWith]="displaySelectedPlan">
            <mat-option *ngFor="let selectPlan of selectPlans" (click)="onPlanSelection(selectPlan)"
              [value]="selectPlan">
              {{selectPlan?.plan_name}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
        <button mat-flat-button (click)="onPlanSelection(searchPlans)" class=" system" color="accent">
          Search Plans
        </button>
      </div>
    </div>
  </form>
</div>


<div class="example-container mat-elevation-z8">
  <mat-table #table [dataSource]="dataSource" matSort (matSortChange)="announceSortChange($event)">

    <ng-container matColumnDef="Action">
      <mat-header-cell *matHeaderCellDef> Action </mat-header-cell>
      <mat-cell *matCellDef="let element">
        <button button mat-raised-button style="color: green">
          <fa-icon [icon]="faedit"></fa-icon>
        </button>
        <!-- <button mat-button color="warn">
          <fa-icon [icon]="fatrash" style="color: red"></fa-icon>
        </button>
        <button button mat-icon-button title="send results email (coming soon)">
          <fa-icon [icon]="faenvelope" style="color: blueviolet"></fa-icon>
        </button>
        <button *ngIf='element.form_id' button mat-icon-button title="Open Rater Form">
          <fa-icon [icon]="faclipboard" style="color: green"></fa-icon>
        </button>
        <button button mat-icon-button title="Job Photos">
          <fa-icon [icon]="facamera" style="color: black"></fa-icon>
        </button> -->
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="Subdivision">
      <mat-header-cell *matHeaderCellDef> Subdivision </mat-header-cell>
      <mat-cell *matCellDef="let element"> {{element.subdivision_name}} </mat-cell>
    </ng-container>

    <!-- Name Column -->
    <ng-container matColumnDef="Lot">
      <mat-header-cell *matHeaderCellDef> Lot </mat-header-cell>
      <mat-cell *matCellDef="let element"> {{element.lot}} </mat-cell>
    </ng-container>

    <!-- Weight Column -->
    <ng-container matColumnDef="Address">
      <mat-header-cell *matHeaderCellDef> Address </mat-header-cell>
      <mat-cell *matCellDef="let element"> {{element.street_address}} </mat-cell>
    </ng-container>
    <ng-container matColumnDef="City">
      <mat-header-cell *matHeaderCellDef> City </mat-header-cell>
      <mat-cell *matCellDef="let element"> {{element.city}} </mat-cell>
    </ng-container>

    <!-- Symbol Column -->
    <ng-container matColumnDef="plan_name">
      <mat-header-cell *matHeaderCellDef> plan_name </mat-header-cell>
      <mat-cell *matCellDef="let element"> {{element.plan_name}} </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
  </mat-table>
</div>
<div>
  <h3>Location Importer (Select CSV)</h3>
  <input type="file" name="file" #file accept=".csv" (click)="parseCSVimporter(file.files)">

  <h3>Job Updater (Select CSV) <a href="" (click)="openInstrModal()">Instructions</a></h3>
  <input type="file" name="file">

  <h3>Job Importer (Select CSV)</h3>
  <input type="file">
</div>